import StockTransfer from '@/api/stock/stock-transfer'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'
import { printPdf } from '../../../api/stock/stock-transfer'

export const state = {
  ...baseState,
  edit_data: {},
  to_warehouses: [],
  branches: [],
  products: [],
  uom: [],
  transfer_type: '',
  location_id: [],
  status_id: 1,
  dateRange: [
    moment()
      .add(-7, 'days')
      .format('DD-MM-YYYY'),
    moment().format('DD-MM-YYYY')
  ]
}

export const getters = {
  productNotIncludeSelected: state => ({
    addedProducts,
    excludeProductId
  } = {}) => {
    // if (addedProducts !== undefined && excludeProductId !== undefined) {
    //   return state.products.filter(
    //     p =>
    //       !_.includes(
    //         addedProducts
    //           .filter(t => t.product_id != excludeProductId)
    //           .map(t => t.product_id),
    //         p.product_id
    //       )
    //   )
    // }

    return state.products
  },
  getUom: state => ObjectRow => {
    let result = state.products.filter(
      p => p.product_id == ObjectRow.product_id
    )
    if (result.length > 0) {
      return state.uom.filter(u => u.uom_cat_id == result[0].uom_cat_id)
    }
    return []
  },
  getDefaultUom: state => productId => {
    if (productId) {
      return state.products
        .filter(p => p.product_id == productId)
        .map(el => el.sale_code)
        .flat()
        .filter(s => s.unit_of_measure.is_default == true)
        .reduce((init, value) => (init = value.uom_id), null)
    }

    return 0
  },
  productPrice: state => (productId, uomId) => {
    try {
      return _.flatten(
        state.products.find(p => p.product_id == productId).sale_code
      ).find(sc => sc.uom_id == uomId).product_price
    } catch (e) {
      return ''
    }
  },
  totalAmount: (state, getters) => detail => {
    try {
      let amount = detail.cost * detail.quantity
      return _.ceil(amount, 2)
    } catch (e) {
      return 0
    }
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_TO_WAREHOUSES(state, data) {
    state.to_warehouses = data
  },
  SET_BRANCHES(state, data) {
    state.branches = data
  },
  SET_PRODUCT(state, data) {
    state.products = data
  },
  SET_UOM(state, data) {
    state.uom = data
  },
  SET_TRANSFER_TYPE(state, data) {
    state.transfer_type = data
  },
  SET_DATE_RANGE(state, date) {
    state.dateRange = date
  },
  SET_LOCATION_ID(state, data) {
    state.location_id = data
  },
  SET_STATUS_ID(state, data) {
    state.status_id = data
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        location_id: context.state.location_id,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ','),
          transfer_type: context.state.transfer_type,
          status_id: context.state.status_id
        }
      },
      attrubutes
    )
    return StockTransfer.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return StockTransfer.store(data)
  },

  update(context, data) {
    return StockTransfer.update(data)
  },
  destroy(context, id) {
    return StockTransfer.destroy(id)
  },

  confirm(context, data) {
    return StockTransfer.updateStatus(data)
  },

  reject(context, data) {
    return StockTransfer.updateStatus(data)
  },

  async getToWarehouses(context, attribute = {}) {
    let response = await StockTransfer.toWarehouse({ params: attribute })
    context.commit('SET_TO_WAREHOUSES', response.data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await StockTransfer.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  async dataBeforeCreate(context) {
    if (!context.state.branches.length > 0) {
      let response = await StockTransfer.branch()
      context.commit('SET_BRANCHES', response.data)
    }
    if (!context.state.products.length > 0) {
      let response = await StockTransfer.product()
      context.commit('SET_PRODUCT', response.data)
    }
    if (!context.state.uom.length > 0) {
      let response = await StockTransfer.uom()
      context.commit('SET_UOM', response.data)
    }
    return Promise.resolve()
  },
  async checkReceiveMonthDiffMonthTransfer(context, data) {
    return await StockTransfer.checkReceiveMonthDiffMonthTransfer(data)
  },
  printPdf(context, attribute = {}) {
    return StockTransfer.printPdf({ params: attribute })
  }
}
